const { REACT_APP_GLIDE_PATH: glidePath } = process.env;

export const getGlidePath = () => `${glidePath}`;

export const getGlidePathAsURL = () => {
  const url = new URL(getGlidePath());

  return url;
};
